import React from "react";
import { useLeafletContext } from "@react-leaflet/core";
import L, { bounds } from "leaflet";
import { useEffect, useRef, useState } from "react";
import {
  MapContainer,
  TileLayer,
  useMap,
  Marker,
  FeatureGroup,
  LayerGroup,
  LayersControl,
  Popup,
  Circle,
  Rectangle,
} from "react-leaflet";
import {
  Button,
  Table,
  Label,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  CardHeader,
} from "reactstrap";
import { Button as ButtonMaterial } from "@mui/material";
import MarkerClusterGroup from "react-leaflet-cluster";
import { Modal, Spinner } from "react-bootstrap";
import {
  useGtSaathiAprrovalbyIdMutation,
  useGtPointCreateBoundaryMutation,
} from "./RiskManagementApiSlice";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "features/auth/authSlice";
import "leaflet/dist/leaflet.css";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import DigitalAgricultureMap from "./DigitalAgricultureMap";

const markerIcon = new L.Icon({
  iconUrl: require("./marker.png"),
  iconSize: [40, 40],
  iconAnchor: [17, 46], //[left/right, top/bottom]
  popupAnchor: [0, -46], //[left/right, top/bottom]
});

const markerIcon2 = new L.Icon({
  iconUrl: require("./marker8.png"),
  iconSize: [40, 40],
  iconAnchor: [17, 46], //[left/right, top/bottom]
  popupAnchor: [0, -46], //[left/right, top/bottom]
});
function getBounds(props) {
  return L.latLng(props.center).toBounds(props.size);
}

function Square(props) {
  const context = useLeafletContext();
  const squareRef = useRef();
  const propsRef = useRef(props);
  useEffect(() => {
    squareRef.current = new L.Rectangle(getBounds(props));
    const container = context.layerContainer || context.map;
    container.addLayer(squareRef.current);
    return () => {
      container.removeLayer(squareRef.current);
    };
  }, []);

  useEffect(() => {
    if (
      props.center !== propsRef.current.center ||
      props.size !== propsRef.current.size
    ) {
      squareRef.current.setBounds(getBounds(props));
    }
    if (props.bounds.length > 1) {
      context.map.fitBounds(props.bounds);
    }
    propsRef.current = props;
  }, [props.center, props.size, props.bounds]);

  return null;
}

function RiskManagementDigitalAgricultureMainMap({
  GtPointSurvey,
  latlongData,
  refetch,
  selectedSurveyType,
}) {
  const [center, setCenter] = useState([28.576592977786234, 77.31433377113422]);
  const [plots, setPLots] = useState([]);
  const [gtAllData, setFullGtPoints] = useState([]);
  const [show, setShow] = useState(false);
  const currentUser = useSelector(selectCurrentUser);
  //  const RoleAcessParams = ["UPDASP-PM"]
  const [cardName, setCardValue] = useState("Details");
  const [cropdata, setDetailList] = useState([]);
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const [editAllowed, setEditAllowed] = useState(false);
  const [SortedArray, setSortedArray] = useState([]);

  const handleActiveCard = (cardName) => {
    setCardValue(cardName);
  };

  useEffect(() => {
    const tempPlots = [];
    const newPLots = [];
    latlongData.map((plot) => {
      if (Array.isArray(plot)) {
        if (plot.length > 0) {
          if (plot[0].lat && plot[0].long) {
            tempPlots.push([plot[0].lat, plot[0].long]);
          }
        }
      }
    });

    setPLots(tempPlots);
    GtPointSurvey.map((item) => {
      if (item?.LatLong?.length > 0) {
        newPLots.push(item);
      }
    });
    setFullGtPoints(newPLots);
  }, [latlongData, GtPointSurvey]);
  // console.log("gtAllData",gtAllData)

  const handleShow = (list) => {
    setDetailList(list);
    setShow(true);
    // if (Array.isArray(list?.Fertilizers)) {
    //   setDetailFertilizerList(list?.Fertilizers);
    // }
    // if (Array.isArray(list?.IrrigationInterval)) {
    //   setDetailIrrigationList(list?.IrrigationInterval);
    // }
  
  };

  const handleClose = (val) => {
    setShow(false);
    setCardValue("Details");
    setEditAllowed(false);
  };
  const handleLightBoxImage = (image) => {
    setImageInLightbox(image);
    setOpenLightBox(true);
  };

  return (
    <>
      <MapContainer
        center={center}
        style={{ height: "50vh", zIndex: 0 }}
        zoom={13}
      >
        <TileLayer
          url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <Square center={center} size={0} bounds={plots} />
        <MarkerClusterGroup chunkedLoading>
          {gtAllData?.map((item, index) => {
            return (
              <p key={index}>
                <Marker
                  position={[item?.LatLong[0].lat, item?.LatLong[0].long]}
                  icon={markerIcon}
                >
                  <Popup>
                    <Table className="table mb-0">
                      <tbody>
                        <tr>
                          <th>Name: </th>
                          <td>{item.CreatedName}</td>
                        </tr>
                        <tr>
                          <th>Survey No: </th>
                          <td>{item.SurveyNo}</td>
                        </tr>
                        <tr>
                          <th>Crop Name: </th>
                          <td>{item.CropName}</td>
                        </tr>
                        <tr>
                          <th>Cropping Type: </th>
                          <td>{item.CroppingTypeName}</td>
                        </tr>
                        <tr>
                          <th>Crop Id: </th>
                          <td>{item.CropId}</td>
                        </tr>
                      </tbody>
                    </Table>
                    <Row>
                      <ButtonMaterial
                        variant="contained"
                        color="success"
                        className=" mt-3"
                        onClick={() => handleShow(item)}
                      >
                        View Details
                      </ButtonMaterial>
                    </Row>
                  </Popup>
                </Marker>
              </p>
            );
          })}
        </MarkerClusterGroup>
      </MapContainer>
      <Modal
        show={show}
        onHide={() => handleClose(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="xl"
      >
        <Modal.Header closeButton style={{ marginTop: "" }}>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="1"></Col>
            <div
              className="radio-inputs text-center"
              style={{ width: "45%", margin: "auto" }}
            >
              <label className="radio">
                <div onClick={() => handleActiveCard("Details")}>
                  <input type="radio" name="radio" defaultChecked />
                  <h4 className="name2  m-0">Details</h4>
                </div>
              </label>

              <label className="radio">
                <div onClick={() => handleActiveCard("Documents")}>
                  <input type="radio" name="radio" />
                  <h4 className="name2 text-primary m-0">Documents</h4>
                </div>
              </label>

              <label className="radio">
                <div onClick={() => handleActiveCard("Geo Tag")}>
                  <input type="radio" name="radio" />
                  <h4 className="name2 text-primary m-0">Geo Tag</h4>
                </div>
              </label>
            </div>

            {cardName === "Details" ? (
              <>
             
                <Card>
                 <CardBody>
                <h6 className="mt-3 mb-3 text-primary">Basic Info</h6>
                <Row className="mb-3">
                  <Col lg="3"><Label>Created Name</Label><Input disabled value={cropdata?.CreatedName || "-"} /></Col>
                  <Col lg="3"><Label>Created Phone No</Label><Input disabled value={cropdata?.CreatedMobile || "-"} /></Col>
                  <Col lg="3"><Label>Lat/Long</Label>
                    <Input disabled value={
                            cropdata.length > 0
                              ? cropdata?.LatLong[0]?.lat.toFixed(4) +
                                "/" +
                                cropdata?.LatLong[0]?.long.toFixed(4)
                              : ""
                           } />
                  </Col>
                </Row>
                
                <h6 className="mt-3 mb-3 text-primary">Crop Details</h6>
                <Row className="mb-3">
                  <Col lg="3"><Label>Crop Name</Label><Input disabled={!editAllowed} value={cropdata?.CropName || "-"} /></Col>
                  <Col lg="3"><Label>Crop Category</Label><Input disabled={!editAllowed} value={cropdata?.CropCategoryName || "-"} /></Col>
                  {selectedSurveyType === "CH" && (
                    <Col lg="3"><Label>Crop Variety</Label><Input disabled value={cropdata?.CropVariety || "-"} /></Col>
                  )}
                  <Col lg="3"><Label>Crop Condition</Label><Input disabled value={cropdata?.CropConditionName || "-"} /></Col>
                </Row>
                
                <h6 className="mt-3 mb-3 text-primary">Cropping Details</h6>
                <Row className="mb-3">
                  <Col lg="3"><Label>Cropping Type</Label><Input disabled={!editAllowed} value={cropdata?.CroppingTypeName || "-"} /></Col>
                  <Col lg="3"><Label>Season</Label><Input disabled value={cropdata?.Season || "-"} /></Col>
                  <Col lg="3"><Label>Sowing Date</Label><Input disabled value={cropdata?.SowingDate || "-"} /></Col>
                  <Col lg="3"><Label>Harvest Date</Label><Input disabled value={cropdata?.HarvestDate || "-"} /></Col>
                  <Col lg="3"><Label>Crop Damage</Label><Input disabled value={cropdata?.CropDamageType || "-"} /></Col>
                </Row>
                
                <h6 className="mt-3 mb-3 text-primary">Area Details</h6>
                <Row className="mb-3">
                  <Col lg="3"><Label>Plot Area</Label><Input disabled={!editAllowed} value={cropdata?.PlotArea || "-"} /></Col>
                  <Col lg="3"><Label>Polygon Area</Label><Input disabled={!editAllowed} value={cropdata?.PolygonArea || "-"} /></Col>
                  <Col lg="3"><Label>Ratio Of Major Crop</Label><Input disabled={!editAllowed} value={cropdata?.RatioOfMajorCrop || "-"} /></Col>
                </Row>
                
                <h6 className="mt-3 mb-3 text-primary">Minor Crop Details</h6>
                <Row className="mb-3">
                  <Col lg="3"><Label>Minor Crop Name</Label><Input disabled={!editAllowed} value={cropdata?.MinorCropName || "-"} /></Col>
                  <Col lg="3"><Label>Minor Crop Category</Label><Input disabled={!editAllowed} value={cropdata?.MinorCropCategoryName || "-"} /></Col>
                  <Col lg="3"><Label>Minor Crop Type</Label><Input disabled={!editAllowed} value={cropdata?.MinorCropType || "-"} /></Col>
                </Row>
                
                {selectedSurveyType === "CH" && (
                  <>
                    <h6 className="mt-3 mb-3 text-primary">Additional Details</h6>
                    <Row className="mb-3">
                      <Col lg="3"><Label>Fertilizer Type</Label><Input disabled={!editAllowed} value={cropdata?.FertilizerType || "-"} /></Col>
                      <Col lg="3"><Label>Expected Avg Yield</Label><Input disabled={!editAllowed} value={cropdata?.ExpectedAvgYield || "-"} /></Col>
                      <Col lg="3"><Label>Expected Yield Of Crop</Label><Input disabled={!editAllowed} value={cropdata?.ExpectedYieldOfCrop || "-"} /></Col>
                    </Row>
                  </>
                )}
                
                <h6 className="mt-3 mb-3 text-primary">Location</h6>
                <Row className="mb-3">
                  <Col lg="3"><Label>State</Label><Input disabled={!editAllowed} value={cropdata?.StateName || "-"} /></Col>
                  <Col lg="3"><Label>District</Label><Input disabled={!editAllowed} value={cropdata?.DistrictName || "-"} /></Col>
                  <Col lg="3"><Label>Village</Label><Input disabled={!editAllowed} value={cropdata?.VillageName || "-"} /></Col>
                </Row>
                
                                      </CardBody>
                </Card>
              </>
            ) : cardName === "Documents" ? (
              <Row>
                {cropdata ? (
                  <Row>
                    {cropdata?.Media
                      ? cropdata?.Media?.map((list, index) =>
                          list.ImagePath !== "" ? (
                            <Col lg={3} key={list.index} className="mt-3">
                              <Card className="text-center border ">
                                <CardBody>
                                  <div className="img-fluid float-left">
                                    <p className="mb-1 text-uppercase">
                                      {list.Attribute}
                                    </p>
                                    <hr className="mt-2" />
                                    {list?.ImagePath?.includes("mp4") ? (
                                      <video width="320" height="240" controls>
                                        <source
                                          src={list.ImagePath}
                                          type="video/mp4"
                                        />
                                        <source
                                          src={list.ImagePath}
                                          type="video/ogg"
                                        />
                                      </video>
                                    ) : list.ImagePath.includes("pdf") ? (
                                      <object
                                        data={list.ImagePath}
                                        type="application/pdf"
                                        width="100%"
                                        height="400px"
                                      />
                                    ) : (
                                      <img
                                        src={list.ImagePath}
                                        onClick={() =>
                                          handleLightBoxImage(list.ImagePath)
                                        }
                                        alt=""
                                        className="img-fluid cursor-pointer"
                                      />
                                    )}
                                    <hr className="mt-2" />
                                    <p className="mb-1 text-uppercase">
                                      Accuracy :{" "}
                                      {list.Metadata
                                        ? list.Metadata.Accuracy
                                        : ""}
                                    </p>
                                    <p className="mb-1 text-uppercase">
                                      Azimuth :{" "}
                                      {list.Metadata
                                        ? list.Metadata.azimuth
                                        : ""}
                                    </p>
                                    <p className="mb-1 text-uppercase">
                                      Elevation :
                                      {list.Metadata
                                        ? list.Metadata.Elevation
                                        : ""}
                                    </p>
                                    {openLightbox ? (
                                      <Lightbox
                                        image={lightBoxViewImage}
                                        title="Image Title"
                                        onClose={() => setOpenLightBox(false)}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          ) : null
                        )
                      : ""}
                  
                  </Row>
                ) : null}
              </Row>
            ) : (
              <DigitalAgricultureMap
                listData={cropdata}
                otherMedia={cropdata.Media}
                benchmarkDetails=""

              />
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RiskManagementDigitalAgricultureMainMap;
